export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-selection/src/selection/empty.js
// module id = 306
// module chunks = 0